// general input masks
$('.cepMask').mask("99999-999");
$('.cpfMask').mask("999.999.999-99");
$('.dataMask').mask("99/99/9999");
$('.foneMask').focusout(function () {
    var phone, element;
    element = $(this);
    element.unmask();
    phone = element.val().replace(/\D/g, '');
    if (phone.length > 10) {
        element.mask("(99) 99999-999?9");
    } else {
        element.mask("(99) 9999-9999?9");
    }
}).trigger('focusout');

function validarEntrada() {
    var valorAtual = $(this).val();
    var textoFiltrado = valorAtual.replace(/[^0-9()\- ]/g, '');
    if (valorAtual !== textoFiltrado) {
        $(this).val(textoFiltrado); // Atualiza o campo com o texto filtrado
    }
}

$('.phoneNumber').on('paste', function(e) {
    // Captura o conteúdo que está sendo colado
    var textoColado = e.originalEvent.clipboardData.getData('text');
    // Filtra apenas os caracteres permitidos
    var textoFiltrado = textoColado.replace(/[^0-9()\- ]/g, '');
    // Define o valor do campo com o texto filtrado
    var posicaoCursor = this.selectionStart;
    var valorAtual = $(this).val();

    // Atualiza o valor do campo de texto
    $(this).val(valorAtual.slice(0, posicaoCursor) + textoFiltrado + valorAtual.slice(posicaoCursor));
    e.preventDefault(); // Impede o comportamento padrão de colar
});

$('.phoneNumber').on('input', validarEntrada);

$(document).on('change','#formContato_estado',function(){
    var uf = $(this).val();
    $("#formContato_cidade").html('<option>Carregando cidades...</option>');
    $.ajax({
        type: "POST",
        data: {uf: uf},
        url: "ajax-cidades.php",
        success: function (result) {
            $("#formContato_cidade").html(result);
        }
    });
});
$(document).on('blur', '#formCarrers_cpf', function () {
    var cpf = $(this).val();
    $.ajax({
        type: "POST",
        data: {cpf: cpf},
        url: "ajax-cpfCurriculos.php",
        success: function (result) {
            var res = result.split('|');
            if(res[1] == 'S'){
                $("#formCarrers_nome").val(res[2]);
                $("#formCarrers_email").val(res[3]);
                $("#formCarrers_telefone").val(res[4]);
                $("#formContato_estado").val(res[5]);
                $("#formCarrers_endereco").val(res[6]);
                $("#formCarrers_mensagem").text(res[7]);
                $("#formContato_cidade").html(res[8]);
                $("#formCarrers_anexo--hidden").removeAttr('required');
                $("#formCarrers_anexo--hidden").removeAttr('aria-required');
            }else{
                $("#formCarrers_anexo--hidden").attr('required','required');
                $("#formCarrers_anexo--hidden").attr('aria-required', 'true');
            }
        }
    });
});

// specific for pages
// change snippet on mobile
if ($('.innerPage').length) {
    changeTouchClickText();
}
if ($('.innerPage.u-fullGradientPage').length) {
    $('footer.l-footer').addClass('js-insideGradientBg');
}
if ($('#page_carreiras').length) {
    $("#formCarrers").validate({
        submitHandler: function (form) {
            //SUBMIT form
            $(form).ajaxSubmit({
                //target: 'status-envio',
                beforeSubmit: function () {
                    $('#status-envio').show();
                    $('#status-envio').html('<span class="c-stsSend__feedback c-stsSend__feedback--load"> Enviando, aguarde...</span>');
                    $('#btnTrabalhe').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    if(parseInt(result[0].charAt(result[0].length-1)) == 1){
                        $('#status-envio').html(result[1]);
                        setTimeout(function(){
                            $('#btnTrabalhe').attr('disabled',false);
                            $("#formCarrers .field").val('');
                            $("#formCarrers textarea").val('').html('');
                            $("#formCarrers_anexo").attr('placeholder','Selecione seu currículo');
                            $("#formCarrers .field").removeClass('error');
                            $('.listOfSelectedJobs').html('<span>Nenhuma vaga selecionada</span>');
                            $('#status-envio').hide();
                            $('#status-envio').empty();
                        },2000);
                    }else{
                        $('#status-envio').html(result);
                        setTimeout(function () {
                            $('#status-envio').hide();
                            $('#status-envio').empty();
                            $('#btnTrabalhe').attr('disabled', false);
                        }, 3000);
                    }
                }
            });
        }
    });
    if (is.mobile()) {
        $('.linkWhatsapp').each(function(){
            var link = $(this).attr('data-mobile-device');
            $(this).attr('href',link);
        })
    }
}
if ($('.module__carrer').length) {
    var classActive = 'is-active';
    var el = {
        head: $('.job__head'),
        head__check: $('.head__check > input'),
        head__cod: $('.head__cod'),
        head__title: $('.head__title'),
        head__readMore: $('.head__readMore'),
        head__share: $('.head__share'),
        head__share__call: $('.share__call'),
        head__share__options: $('.share__options'),
        head__share__close: $('.js-options__close'),
        head__share__copyLink: $('.js-copyLink'),
        head__share__whatsapp: $('.js-whatsappLink'),

        infos: $('.job__infos'),
        infos__select: $('.select__check'),
    };
    var whatsappOptions = {
        address: 'http://www.canguru.com.br/carreiras',
        company: 'Canguru',
        link_mobile: 'https://api.whatsapp.com/send?text=',
        link_web: 'https://web.whatsapp.com/send?text=',
    };

    // open/close job content
    function openCloseJobs(element) {
        element.closest('.job__hero').toggleClass(classActive);
    }
    el.head__title.on('click', function(){openCloseJobs($(this))});
    el.head__readMore.on('click', function(){openCloseJobs($(this))});

    // select jobs
    // create array with selected jobs
    function createArrayWithSelectedJobs() {
        var selectedJobs = [];
        el.head__check.each(function(index) {
            if ($(this).is(':checked')) {
                var nameJob = $(this).closest('.job__head').find('h4').html();
                var codeJob = $(this).closest('.job__head').find('.head__cod').html();
                var code = $(this).closest('.job__head').find('.head__cod').attr('data-codigo');
                selectedJobs.push('<span><input type="hidden" name="vagas[]" value="'+code+'">' + codeJob + ': ' + nameJob + '</span>');
            }
            $('.listOfSelectedJobs').html(selectedJobs);
        });
        if(selectedJobs.length === 0) {
            $('.listOfSelectedJobs').html('<span>Nenhuma vaga selecionada</span>');
        }
        return selectedJobs;
    }
    el.infos__select.on('click', function() {
        if($(this).hasClass(classActive)) {
            $(this).removeClass(classActive);
            $(this).children('span').html('Selecionar esta vaga');
            $(this).closest('.job__hero').children('.job__head').find('.head__check > input').prop('checked', false);
        } else {
            $(this).addClass(classActive);
            $(this).children('span').html('Vaga selecionada');
            $(this).closest('.job__hero').children('.job__head').find('.head__check > input').prop('checked', true);
        }
        createArrayWithSelectedJobs();
    });
    el.head__cod.on('click', function() {
        if($(this).closest('.job__hero').children('.job__head').find('.head__check > input').is(':checked')) {
            $(this).closest('.job__hero').children('.job__head').find('.head__check > input').prop('checked', false);
            $(this).closest('.job__hero').children('.job__infos').find('.select__check').removeClass(classActive).children('span').html('Selecionar esta vaga')
        } else {
            $(this).closest('.job__hero').children('.job__head').find('.head__check > input').prop('checked', true);
            $(this).closest('.job__hero').children('.job__infos').find('.select__check').addClass(classActive).children('span').html('Vaga selecionada')
        }

        createArrayWithSelectedJobs()
    });
    el.head__check.on('click', function() {
        if($(this).is(':checked')) {
            $(this).closest('.job__hero').find('.select__check').addClass(classActive);
            //el.infos__select.addClass(classActive);
        } else {
            $(this).closest('.job__hero').find('.select__check').removeClass(classActive);
            //el.infos__select.removeClass(classActive);
        }
        createArrayWithSelectedJobs();
    });

    // load with hash
    $(window).on('load hashchange', function() {
        var hashPage = window.location.hash;
        if ((hashPage == '') || (hashPage == 'undefined')) {
        } else if (hashPage === '#envio-curriculo') {
            goToSection__scroll($('.stepCarrer--2'), 100);
        } else {
            el.head__cod.each(function() {
                if(hashPage == $(this).text()) {
                    $(this).closest('.job__hero').addClass(classActive);
                    goToSection__scroll($('.job__hero.is-active'), 100);
                    return false
                }
            });
        }
    });

    // share options - open
    el.head__share__call.on('click', function() {
        $(this).closest('.head__share').children('.share__options').addClass(classActive);
    });
    // share options - close
    el.head__share__close.on('click', function(event) {
        event.preventDefault();
        $(this).closest('.head__share').children('.share__options').removeClass(classActive);
    });
    // share options - copy link
    el.head__share__copyLink.on('click', function(event) {
        event.preventDefault();
        var inputElement = $(this).children('.inputLinkHero').children('input');
        var jobCode = $(this).closest('.job__head').children('.head__cod').text();
        var fullUrl = window.location.href;
        var hashOfPage = window.location.hash;

        if ((hashOfPage == 'undefined') || (hashOfPage == '')) {
            inputElement.val(fullUrl + jobCode);
        } else {
            var urlInicial = fullUrl.split(hashOfPage, 1);
            var urlPage = urlInicial + jobCode;
            inputElement.val(urlPage);
        }

        inputElement.select();
        document.execCommand("copy");
        $(this).children('.inputLinkHero').children('span').addClass('is-active');
        setTimeout(function(){
            $('.inputLinkHero span').removeClass('is-active');
        }, 1500);
    });
    // share options - whatsapp
    el.head__share__whatsapp.on('click', function(event) {
        event.preventDefault();
        // make link vaga
        var selectedJobCode = $(this).closest('.job__head').children('.head__cod').html();
        var finalLink = whatsappOptions.address + selectedJobCode;
        //make msg vaga
        var selectedJobName = $(this).closest('.job__head').children('.head__title').children('h4').text();
        var textLink = 'Olá, gostaria de compartilhar com você essa vaga de *' + selectedJobName + '*, na empresa *' + whatsappOptions.company + '* - ' + finalLink;
        // open whats
        if(is.mobile() || is.tablet()) {
            window.open(whatsappOptions.link_mobile + textLink);
        } else {
            window.open(whatsappOptions.link_web + textLink);
        }
    });

    // attach cv
    $('#formCarrers_anexo--hidden').on('change', function() {
        var t = $(this).val().split('fakepath');
        $('#formCarrers_anexo').attr('placeholder', t[1]);
    });

    // remove module 01 if doesnt exists jobs
    if(!$('.job__hero').length) {
        $('.stepCarrer--1').remove();
        $('.stepCarrer--2 h3').remove();
        $('js-listOfSelectedJobs').remove();
        $('.js-textCv').text('Preencha o formulário abaixo para enviar seu currículo.');
    }
}
if ($('#page_contato').length) {
    $("#formContato").validate({
        submitHandler: function (form) {
            //SUBMIT form
            $(form).ajaxSubmit({
                //target: 'status-envio',
                beforeSubmit: function () {
                    $('#status-envio').show();
                    $('#status-envio').html('<span class="c-stsSend__feedback c-stsSend__feedback--load"> Enviando, aguarde...</span>');
                    $('#btnContato').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    if(parseInt(result[0].charAt(result[0].length-1)) == 1){
                        $('#status-envio').html(result[1]);
                        setTimeout(function(){
                            $('#btnContato').attr('disabled',false);
                            $("#formContato .field").val('');
                            $("#formContato textarea").val('').html('');
                            $("#formContato .field").removeClass('error');
                            $('#status-envio').hide();
                            $('#status-envio').empty();
                        },2000);
                    }else{
                        $('#status-envio').html(result);
                        setTimeout(function () {
                            $('#status-envio').hide();
                            $('#status-envio').empty();
                            $('#btnContato').attr('disabled', false);
                        }, 3000);
                    }
                }
            });
        }
    });
}
if ($('#page_institucional').length) {
    // historia
    var swiper__futuro = new Swiper('.swiper__futuro', {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        watchSlidesVisibility: true,
        touchRatio: 0,
        allowTouchMove: false,
        autoHeight: true,
    });
    $('.futuro__head li span').on('click', function(e) {
        e.preventDefault();

        // style active/inactive
        $('.futuro__head li').removeClass('is-active');
        $(this).parent('li').addClass('is-active');

        // change slide
        setTimeout(function(){swiper__futuro.updateAutoHeight();}, 1000);
        var slideDestiny = $(this).attr('data-slide');
        swiper__futuro.slideTo(slideDestiny - 1, 600);
    });

    // premiacoes
    var swiper__premiacoes = new Swiper('.swiper__premiacoes', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        centeredSlides: true,
        autoplay: {
            delay: 1500,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
}
if ($('#page_solucoes').length) {
    // clientes da categoria
    function makeSwiperClientes() {
        var swiper__clientesInner = new Swiper('.swiper__clientesInner', {
            slidesPerView: 'auto',
            spaceBetween: 0,
            centeredSlides: 'true',
            loop: true,
            preloadImages: true,
            updateOnImagesReady: true,
            autoplay: {
                delay: 2500,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }
    function ajaxSolucoes(finalUrl) {
        $.ajax({
            type: "POST",
            url: 'ajaxSolucoes',
            //url: 'components/solucoes_ajax/ajaxSolucoes.php',
            data: {url:finalUrl},
            beforeSend: function() {
                $('.c-loader').removeClass('u-dnone');
            },
            success: function(data) {
                $('.hero_contentAjax').html(data);
            },
            complete: function() {
                //$('.c-loader').addClass('u-dnone');
                setTimeout(function(){
                    $('.c-loader').addClass('u-dnone');
                    makeSwiperClientes();
                    goToSection__scroll('.s-grid__solucoes', 0);
                }, 500);
                setTimeout(function(){
                    $('.hero_contentAjax').removeClass('is-empty');
                }, 700);
            }
        });
    }
    function turnOnActiveCard() {
        var finalCard = window.location.hash.replace('#', '');
        $(".s-grid__solucoes .c-cardProdutos").removeClass('is-active');
        $(".s-grid__solucoes .c-cardProdutos[data-conteudo="+finalCard+"]").addClass('is-active');
        return finalCard;
    }
    function changeContentOnHashChange() {
        var finalUrl = window.location.hash.replace('#', '');
        if(finalUrl != '') {
            ajaxSolucoes(finalUrl);
            turnOnActiveCard();
        }
    }
/*    function changeContentOnHashChange() {
        switch(window.location.hash) {
            case '#higienicos':
                var finalUrl = ('components/solucoes_ajax/higienicos.php');
                ajaxSolucoes(finalUrl);
                turnOnActiveCard();
                break;
            case '#limpeza':
                var finalUrl = ('components/solucoes_ajax/limpeza.php');
                ajaxSolucoes(finalUrl);
                turnOnActiveCard()
                break;
            case '#outros':
                var finalUrl = ('components/solucoes_ajax/outros.php');
                ajaxSolucoes(finalUrl);
                turnOnActiveCard()
                break;
            case '#nutricaoanimal':
                var finalUrl = ('components/solucoes_ajax/nutricaoanimal.php');
                ajaxSolucoes(finalUrl);
                turnOnActiveCard()
                break;
            case '#alimenticio':
                var finalUrl = ('components/solucoes_ajax/alimenticio.php');
                ajaxSolucoes(finalUrl);
                turnOnActiveCard()
                break;
            case '#saude':
                var finalUrl = ('components/solucoes_ajax/saude.php');
                ajaxSolucoes(finalUrl);
                turnOnActiveCard()
                break;
        }
    }*/
    $('.s-grid__solucoes a').on('click', function(event) {
        event.preventDefault();
        // hide content and show loader
        $('.hero_contentAjax').addClass('is-empty');
        $('.c-loader').removeClass('u-dnone');
        // apply active style on list solucoes
        $('.s-grid__solucoes a').removeClass('is-active');
        $(this).addClass('is-active');
        // make url to ajax call
        var carregaUrl = $(this).attr('data-conteudo');
        var finalUrl = ('components/solucoes_ajax/'+carregaUrl+'.php');
        window.location.hash = carregaUrl;
        //ajaxSolucoes(finalUrl);
    });
    $(window).on('hashchange load', function() {
        changeContentOnHashChange();
    });
}

if ($('.asideBlog__widget--categorias').length) {
    $('.js-showCategories').on('click', function() {
        $(this).toggleClass('is-active');
        $(this).parent('div').children('ul').toggleClass('is-active');
    });
}